import Reflux from "reflux";
const RequestActions = {
  query: Reflux.createAction(),
};
export { RequestActions };
